import type { AnyAction, PayloadAction } from '@reduxjs/toolkit';
import { createSelector, createSlice } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import type { Account, User } from '@foundershub/api-client';

export interface Slice {
  account: Account | null | undefined;
}

const initialState: Slice = { account: undefined };

const slice = createSlice({
  name: 'account',
  initialState,
  reducers: {
    setAccount: (state: Slice, action: PayloadAction<Account>) => {
      state.account = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      (action: AnyAction) => action.type === 'api/executeQuery/fulfilled',
      (state, action: PayloadAction<User | void>) => {
        if (!action.payload || !('accounts' in action.payload)) {
          return;
        }

        const newAccount = !state.account
          ? action.payload.accounts[0]
          : action.payload.accounts.find((account) => state.account && account.id === state.account.id);

        state.account = newAccount || null;
      }
    );
  },
});

export function useAccount() {
  return useSelector((state: { account: Slice }) => state.account.account);
}

export const selectAccount = createSelector(
  (state: { account: Slice }) => state.account,
  (state) => state.account
);

export default slice;
